export const rules = {
    guest_id: [{
        required: true,
        message: 'Пожалуйста, введите название ',
        trigger: 'change'
    },]
};
